import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import { Link } from "react-router-dom";

import moment from "moment";

import DatePicker from "react-datepicker";

var SchoolInfoModal = require("components/org/roster/SchoolInfoModal");

var CRMActions = require("lib/actions/CRMActions");
var CRMSelectors = require("lib/selectors/CRMSelectors");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

var DropDownOptions = require("components/utility/DropDownOptions");

var OrgTypes = require("lib/academic/OrgTypes");
var CurrentUser = require("lib/account/CurrentUser");
var DateSpans = require("lib/data/DateSpans");
var AccountPlans = require("lib/account/AccountPlans");
var Glyphicon = require("components/utility/icons/Glyphicon");
var Spinner = require("components/utility/Spinner");

require("appdev/crm/upgrade_token_page.scss");

@connect(
	(state, props) => {
		var dealID = $wr.getURLParameterByName("deal_id");

		if (dealID) {
			var deal = CRMSelectors.deal({ state, id: $wr.getURLParameterByName("deal_id"), key: "index" });
		}

		return {
			upgradeTokens: RosterSelectors.upgradeTokens({ state }),
			loadingUpgradeTokens: RosterSelectors.isLoadingUpgradeTokens({ state }),
			deal
		}
	},
	(dispatch, props) => ({
		populateData: () => {
			var dealID = $wr.getURLParameterByName("deal_id");
			if (dealID) {
				return dispatch(CRMActions.fetchDeal({
					id: dealID, embeds: ["deal.org", "org.child_orgs", "deal.contact"]
				}));
			} else {
				return Promise.resolve()
			}
		},

		fetchUpgradeTokens: (page, filters, reset) => {
			if (reset) {
				dispatch(RosterActions.clearUpgradeTokens({}))
			}

			return dispatch(RosterActions.fetchUpgradeTokens({
				embeds: ["upgrade_token.user"],
				filters: { ...filters, page, per_page: 50 },
				loading: ((page || 1) > 1 ? "page" + page : "index")
			}))
		},

		updateUpgradeTokens: (tokenID, update) => {
			return dispatch(RosterActions.updateUpgradeToken({ id: tokenID, update: update }))
		},

		createTokens: (upgradeTokens) => {
			return dispatch(RosterActions.createUpgradeTokens({ upgradeTokens }))
		},

		deleteToken: (id) => {
			return dispatch(RosterActions.deleteUpgradeToken({ id }))
		}

	})
)
@providePopulateData({ waitForLoad: true })
class UpgradeTokenPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = _.extend({}, this.getInitialFormState(props), this.getInitialFilterState(props), {
			page: 1, copyMode: false, editingFields: {}, editedInformation: {}, loading: false
		});
	}

	getInitialFormState(props) {
		props || this.props;
		var tokenPlanType, tokenHasRLD, tokenInvoiceNumber, tokenDealID,
			orgData, schoolOrgID, districtOrgID;

		if (props.deal) {
			tokenDealID = props.deal.id;

			var planType = props.deal.custom_fields["Plan Type"];
			if (planType) {
				tokenPlanType = AccountPlans.nameToKey(planType);
			}

			var tokenHasRLD = !!props.deal.custom_fields["Reading Level Diagnostics"];

			tokenInvoiceNumber = props.deal.custom_fields["Invoice No."];

			var org = props.deal.org;
			if (org) {
				if (org.custom_fields["School Org ID"]) {
					schoolOrgID = org.custom_fields["School Org ID"];
					orgData = {
						name: org.name,
						canonical_id: org.custom_fields["Canonical School ID"]
					}

				} else if (org.custom_fields["District Org ID"]) {
					districtOrgID = org.custom_fields["District Org ID"];

					orgData = {
						name: org.name
					}

				}

			}
		}

		if (props.deal && props.deal.owner) {
			var senderName = props.deal.owner.name;
			var senderEmailPrefix = props.deal.owner.email.split("@")[0];
		} else {
			var user = CurrentUser.get();
			var senderName = user.display_name;
			if (user.email) {
				var senderEmailPrefix = user.email.split("@")[0];
			}
		}

		tokenPlanType = tokenPlanType || AccountPlans.PAID_PLANS[0];

		return {
			newTokenCount: 1,

			showSchoolModal: false, showBulk: false, bulkText: "",
			tokenStartDate: moment().format(DateSpans.FORMAT),

			tokenNames: {}, tokenEmails: {},
			tokenClassCounts: {}, tokenUserTypes: {},

			senderName, senderEmailPrefix,
			tokenPlanType, tokenHasRLD, tokenInvoiceNumber, tokenDealID, orgData,
			schoolOrgID, districtOrgID,

			asTrial: false, trialDays: 30, trialLabel: "", maxStudentOverride: null, maxStudentListsOverride: null
		};
	}

	orgDataForSchoolOrgID(soID, props) {
		props = props || this.props;
		soID = soID + "";

		var school = props.deal.org.child_orgs.find((childOrg) => {
			return childOrg.custom_fields["School Org ID"] === soID
		})

		if (school) {
			return {
				name: school.name,
				canonical_id: school.custom_fields["Canonical School ID"]
			}
		}
	}

	isDistrict() {
		return this.props.deal && this.props.deal.org &&
			this.props.deal.org.custom_fields["Org Level"] === "District";
	}

	getInitialFilterState(props) {
		props || this.props;

		return {
			filterDealID: $wr.getURLParameterByName("deal_id") || "",
			filterSchoolName: "", filterCode: "",
			filterContactName: "", filterContactEmail: ""
		}
	}

	getFilterQuery() {
		var query = {};

		if (this.state.filterDealID.trim().length > 0) {
			query.deal_id = this.state.filterDealID;
		}
		if (this.state.filterSchoolName.trim().length > 0) {
			query.contact_school = this.state.filterSchoolName;
		}
		if (this.state.filterCode.trim().length > 0) {
			query.code = this.state.filterCode;
		}
		if (this.state.filterContactName.trim().length > 0) {
			query.contact_name = this.state.filterContactName;
		}
		if (this.state.filterContactEmail.trim().length > 0) {
			query.contact_email = this.state.filterContactEmail;
		}
		return query;
	}

	increaseNewTokenCount(e) {
		$wr.nope(e);
		this.setState({ newTokenCount: this.state.newTokenCount + 1 });
	}

	onSelectSchool(orgData) {
		this.setState({ showSchoolModal: false, orgData })
	}

	openSchoolModal(e) {
		this.setState({ showSchoolModal: true });
	}

	onSelectPlanType(e) {
		var value = e.target.value;
		if (value.includes("-trial")) {
			var planType = value.replace("-trial", "");
			this.setState({ tokenPlanType: planType, asTrial: true });
		} else {
			this.setState({ tokenPlanType: value, asTrial: false });
		}
	}

	updateTokenField(fieldKey, index, value) {
		var updated = _.extend({}, this.state[fieldKey], { [index]: value });
		this.setState({ [fieldKey]: updated });
	}

	loadBulkText() {
		var lines = _.map(this.state.bulkText.split("\n"), (x) => x.split(" - "));
		
		var tokenNames = {};
		var tokenEmails = {};
		var tokenClassCounts = {};
		var tokenUserTypes = {};

		_.each(lines, (line, index) => {
			if (line.length == 3) {
				tokenNames[index] = line[0].trim();
				tokenEmails[index] = line[1].trim();

				var part3 = line[2].trim();

				if (part3 == SUB_ADMIN_TYPE) {
					tokenUserTypes[index] = SUB_ADMIN_TYPE;
				} else if (part3 == HEAD_ADMIN_TYPE) {
					tokenUserTypes[index] = HEAD_ADMIN_TYPE;
				} else {
					tokenClassCounts[index] = parseInt(part3) + "";					
				}
			}
		});

		var newTokenCount = _.size(tokenNames) || 1; // At least 1

		this.setState({
			newTokenCount, tokenNames, tokenEmails, tokenClassCounts, tokenUserTypes,
			showBulk: false, bulkText: ""
		});
	}

	deleteToken(tokenID, e) {
		$wr.nope(e);
		if (confirm("Are you sure you want to delete this?")) {
			this.props.deleteToken(tokenID);			
		}
	}

	createTokens() {
		var tokenBase = {
			plan_type: this.state.tokenPlanType,
			start_date: this.state.tokenStartDate,
			invoice_number: this.state.tokenInvoiceNumber,
			deal_id: this.state.tokenDealID,
			school_org_id: this.state.schoolOrgID,
			district_org_id: this.state.districtOrgID,
			sender_email: this.state.senderEmailPrefix + SENDER_EMAIL_SUFFIX,
			sender_name: this.state.senderName,
			has_rlds: !!this.state.tokenHasRLD,
			max_students_count_override: this.state.maxStudentOverride,
			max_student_list_count_override: this.state.maxStudentListsOverride
		}

		if (this.state.orgData) {
			tokenBase.contact_school = this.state.orgData.name,
			tokenBase.contact_canonical_id = this.state.orgData.canonical_id
		}

		var tokens = [];

		if (this.state.asTrial) {
			_.times(this.state.newTokenCount, (index) => {
				var token = _.extend({}, tokenBase, {
					contact_name: this.state.trialLabel,
					trial_days: this.state.trialDays
				});

				tokens.push(token);
			})

		} else {
			_.times(this.state.newTokenCount, (index) => {
				if (this.state.districtOrgID) {
					var userType = this.state.tokenUserTypes[index] || HEAD_ADMIN_TYPE;					
				} else {
					var userType = this.state.tokenUserTypes[index] || TEACHER_TYPE;
				}
				var token = _.extend({}, tokenBase, {
					admin_type: userType,
					contact_name: this.state.tokenNames[index],
					contact_email: this.state.tokenEmails[index],
					student_list_count: (this.state.tokenClassCounts[index] || 0)
				});

				if (token.student_list_count || (userType !== TEACHER_TYPE)) {
					tokens.push(token);
				}
			})
		}

		this.props.createTokens(tokens);
		this.setState(this.getInitialFormState(this.props));
	}

	loadMoreTokens() {
		var nextPage = this.state.page + 1;
		this.props.fetchUpgradeTokens(nextPage, this.getFilterQuery()).then(() => {
			this.setState({ page: nextPage });
		})
	}

	onFilter() {
		this.props.fetchUpgradeTokens(1, this.getFilterQuery(), true).then(() => {
			this.setState({ page: 1 });
		})
	}

	onResetFilter() {
		this.setState(this.getInitialFilterState(), this.onFilter);
	}

	toggleCopyMode(e) {
		$wr.nope(e);
		this.setState({ copyMode: !this.state.copyMode });
	}

	renderTokenFilter() {
		return (
			<div className="filters">
				<label>
					Deal ID
					<input className="form-control" value={ this.state.filterDealID }
						placeholder="Exact"
						onChange={ (e) => this.setState({ filterDealID: e.target.value }) } />
				</label>
				<label>
					School
					<input className="form-control" value={ this.state.filterSchoolName }
						placeholder="Partial"
						onChange={ (e) => this.setState({ filterSchoolName: e.target.value }) } />
				</label>
				<label>
					Contact Name
					<input className="form-control" value={ this.state.filterContactName }
						placeholder="Partial"
						onChange={ (e) => this.setState({ filterContactName: e.target.value }) } />
				</label>
				<label>
					Contact Email
					<input className="form-control" value={ this.state.filterContactEmail }
						placeholder="Exact"
						onChange={ (e) => this.setState({ filterContactEmail: e.target.value }) } />
				</label>
				<label>
					Code
					<input className="form-control" value={ this.state.filterCode }
						placeholder="Exact"
						onChange={ (e) => this.setState({ filterCode: e.target.value }) } />
				</label>
				<div className="controls">
					<button className="btn-link" onClick={ this.onResetFilter }>
						Reset
					</button>
					<button className="buttonPrimary" onClick={ this.onFilter }>
						Filter
					</button>
				</div>
			</div>
		)
	}

	renderCopyModeTokens() {
		var tokens = _.sortBy(this.props.upgradeTokens, (x) => x.is_closed + x.id).reverse();

		var tokenRows = _.map(tokens, (upgradeToken) => {
			var label = _.select(
				[upgradeToken.contact_name, upgradeToken.contact_email], 
				(x) => x && x.trim().length > 0
			).join(" - ");
			return (
				<div key={ upgradeToken.id }>
					<strong>{ label }</strong><br/>
					Code: { upgradeToken.code }{ upgradeToken.is_closed ? " (Used)" : "" }
					<br /><br />
				</div>
			);
		})

		return (
			<div>
				{ tokenRows }
			</div>
		);
	}
	updateEditedInformation(attribute, tokenID, inputDataType, event = null, callback = null) {
		var updatedInformation = _.clone(this.state.editedInformation);
		updatedInformation[tokenID] = updatedInformation[tokenID] || {}
		if (inputDataType === 'checkbox') {
			updatedInformation[tokenID][attribute] = event ? event.target.checked : null;
		} else {
			updatedInformation[tokenID][attribute] = event ? event.target.value : null;
		}
		this.setState({ editedInformation: updatedInformation }, () => {
			if (callback) { callback(); }
		});
	}
	// submit if enter key is pressed
	onEditKeyPress(attribute, tokenID, event) {
		if (event.keyCode == 13) {
			this.submitAndToggle(attribute, tokenID);
		}
	}

	submitAndToggle(attribute, tokenID) {
		this.submitEditedInformation(attribute, tokenID);
		this.toggleEdit(attribute, tokenID);
	}

	toggleEdit(attribute, tokenID) {
		var updatedEditingFields = _.clone(this.state.editingFields);
		updatedEditingFields[tokenID] = updatedEditingFields[tokenID] || {}
		if (attribute === CONTACT_NAME) {
			updatedEditingFields[tokenID][CONTACT_NAME] = _.findWhere(this.props.upgradeTokens, { id: tokenID })[CONTACT_NAME];
			updatedEditingFields[tokenID][CONTACT_EMAIL] = _.findWhere(this.props.upgradeTokens, { id: tokenID })[CONTACT_EMAIL];
		} else if (_.contains(PLAN_OPTIONS, attribute)) {
			updatedEditingFields[tokenID][PLAN_TYPE] = _.findWhere(this.props.upgradeTokens, { id: tokenID })[PLAN_TYPE];
			updatedEditingFields[tokenID][STUDENT_LIST_COUNT] = _.findWhere(this.props.upgradeTokens, { id: tokenID })[STUDENT_LIST_COUNT];
			updatedEditingFields[tokenID][HAS_RLDS] = _.findWhere(this.props.upgradeTokens, { id: tokenID })[HAS_RLDS];
		}
		else {
			updatedEditingFields[tokenID][attribute] = _.findWhere(this.props.upgradeTokens, { id: tokenID })[attribute];			
		}
		this.setState({ editingFields: updatedEditingFields });
	}

	submitEditedInformation(attribute, tokenID) {
		var tokenObj = this.state.editedInformation[tokenID];
		if (tokenObj) {
			var updatedValue = tokenObj[attribute];
			if (updatedValue != null) {
				this.setState({ loading: true });
				this.props.updateUpgradeTokens(tokenID, tokenObj).then(() => {
					setTimeout(function () {
						window.wrNotifications.triggerDropDownNotification({
							title: "Information Edited", icon: "ok-sign"
						});
					}.bind(this), 1000);
					// clear attribute from state
					var updatedEditingFields = _.clone(this.state.editingFields);
					var updatedEditedInformation = _.clone(this.state.editedInformation);

					if (attribute === CONTACT_NAME) {
						delete updatedEditingFields[tokenID][CONTACT_NAME]
						delete updatedEditingFields[tokenID][CONTACT_EMAIL]

						delete updatedEditedInformation[tokenID][CONTACT_NAME]
						delete updatedEditedInformation[tokenID][CONTACT_EMAIL]
					} else if (_.contains(PLAN_OPTIONS, attribute)) {
						delete updatedEditingFields[tokenID][PLAN_TYPE]
						delete updatedEditingFields[tokenID][STUDENT_LIST_COUNT]
						delete updatedEditingFields[tokenID][HAS_RLDS]

						delete updatedEditedInformation[tokenID][PLAN_TYPE]
						delete updatedEditedInformation[tokenID][STUDENT_LIST_COUNT]
						delete updatedEditedInformation[tokenID][HAS_RLDS]
					} else {
						delete updatedEditingFields[tokenID][attribute]
						delete updatedEditedInformation[tokenID][attribute]
					}

					this.setState({ editingFields: updatedEditingFields, editedInformation: updatedEditedInformation });
				})
			}
		}
	}

	renderEditableTokenAttributes(upgradeToken, attribute, inputDataType) {
		var displayedAttribute = upgradeToken[attribute];

		if (inputDataType === 'date' && displayedAttribute) {
			displayedAttribute = moment(displayedAttribute).format('M/DD/YY')
		}
		if (this.state.editingFields[upgradeToken.id] && this.state.editingFields[upgradeToken.id][attribute] !== undefined) {
			if (attribute === CONTACT_NAME) {
				if (upgradeToken.deal_id) {
					var dealLinkBase = "https://app.futuresimple.com/sales/deals/";
					var dealLink = (
						<a href={dealLinkBase + upgradeToken.deal_id} target="_blank">
							<Glyphicon icon="link" />
						</a>
					)
				}
				return (
					<td>
					Contact Name: <input type={inputDataType} defaultValue={upgradeToken[CONTACT_NAME]}
						onKeyDown={this.onEditKeyPress.bind(this, CONTACT_NAME, upgradeToken.id)}
							onChange={this.updateEditedInformation.bind(this, CONTACT_NAME, upgradeToken.id, inputDataType,)}
						className="form-control editableField" />
					Contact Email: <input type={inputDataType} defaultValue={upgradeToken[CONTACT_EMAIL]}
						onKeyDown={this.onEditKeyPress.bind(this, CONTACT_EMAIL, upgradeToken.id)}
							onChange={this.updateEditedInformation.bind(this, CONTACT_EMAIL, upgradeToken.id, inputDataType,)}
							className="form-control editableField" />
						{dealLink}
					</td>
				)
			} else if (attribute === PLAN_TYPE) {
				return (
					<td>
						Plan Type: <select defaultValue={upgradeToken[PLAN_TYPE]} className="form-control"
							onChange={this.updateEditedInformation.bind(this, PLAN_TYPE, upgradeToken.id, inputDataType)}
							onKeyDown={this.onEditKeyPress.bind(this, PLAN_TYPE, upgradeToken.id)}
							className="form-control editableField">
							{DropDownOptions.Select.PaidPlanOptions()}
							{DropDownOptions.Select.PaidPlanTrialOptions()}
						</select>
						Class Count: <input type='number' defaultValue={upgradeToken[STUDENT_LIST_COUNT]}
							onKeyDown={this.onEditKeyPress.bind(this, STUDENT_LIST_COUNT, upgradeToken.id)}
							onChange={this.updateEditedInformation.bind(this, STUDENT_LIST_COUNT, upgradeToken.id, 'number')}
							className="form-control editableField" />
						Had RLDS: <input type='checkbox' data-tag='rldsCheckbox'
							defaultChecked={!!upgradeToken[HAS_RLDS]}
							onKeyDown={this.onEditKeyPress.bind(this, HAS_RLDS, upgradeToken.id)}
							onChange={this.updateEditedInformation.bind(this, HAS_RLDS, upgradeToken.id, 'checkbox')}
							className="form-control editableField rldsCheckbox" />
					</td>
				)
			} else {
				return (
					<td>
						<input type={inputDataType} defaultValue={displayedAttribute}
							onKeyDown={this.onEditKeyPress.bind(this, attribute, upgradeToken.id)}
							onChange={this.updateEditedInformation.bind(this, attribute, upgradeToken.id, inputDataType)}
							className="form-control editableField" />
					</td>
				);
			}
		} else {
			var editIcon = (<Glyphicon icon="pencil" className="editIcon" />);
			if (attribute === START_DATE) {
				var displayStartDate = moment(upgradeToken[START_DATE]).format('M/DD/YY')
				var displayEndDate = moment(upgradeToken[CREATED_AT]).format('M/DD/YY')
				return (
					<td className="editable" onClick={this.toggleEdit.bind(this, attribute, upgradeToken.id)}>
						Start Date: <span className="clickableElement">{displayStartDate}</span> {editIcon}<br />
						Created At: <span >{displayEndDate}</span>
					</td>
				)
			} else if (attribute === PLAN_TYPE) {
				var planName = AccountPlans.displayName(upgradeToken[PLAN_TYPE])
				if (upgradeToken.trial_days) {
					var planContent = [planName, upgradeToken.trial_days, "day", "trial"].join(" ");
				} else if (upgradeToken.admin_type !== TEACHER_TYPE) {
					var planContent = planName + ", " + upgradeToken.admin_type;
				} else {
					var classCountText = $wr.pluralizeWithNumber("class",
						upgradeToken.student_list_count, "classes");
					var planContent = planName + ", " + classCountText;
				}

				if (upgradeToken.has_rlds) {
					planContent += " + RLDs";
				}

				return (
					<td className="editable" onClick={this.toggleEdit.bind(this, PLAN_TYPE, upgradeToken.id)}>
						<span className="clickableElement">{planContent}</span> {editIcon}
					</td>
				)
			} else if (attribute === CONTACT_NAME) {
				if (!upgradeToken[CONTACT_NAME] && !upgradeToken[CONTACT_EMAIL]) {
					return (
						<td className="editable" onClick={this.toggleEdit.bind(this, CONTACT_NAME, upgradeToken.id)}>
							<span className="clickableElement">{upgradeToken[CONTACT_NAME]}</span> {editIcon}<br />
						</td>
					)
				} else {
					return (
						<td className="editable" onClick={this.toggleEdit.bind(this, CONTACT_NAME, upgradeToken.id)}>
							Contact Name: <span className="clickableElement">{upgradeToken[CONTACT_NAME]}</span> {editIcon}<br />
							Contact Email: <span className="clickableElement">{upgradeToken[CONTACT_EMAIL]}</span>
						</td>
					)
				}
			} else {
				return (
					<td className="editable" onClick={this.toggleEdit.bind(this, attribute, upgradeToken.id)}>
						<span className="clickableElement">{displayedAttribute}</span> {editIcon}
					</td>
				);
			}
		}
	}

	renderExistingTokensTable() {

		var tokens = _.sortBy(this.props.upgradeTokens, "id").reverse();
		var tokenRows = _.map(tokens, (upgradeToken) => {
			if (upgradeToken.is_closed) {
				var upgradeIcon = (
					<span>
						<Glyphicon icon="ok" />{" "}
					</span>
				);
			} else {
				var deleteIcon = (
					<a href="#" className="deleteLink"
						onClick={ this.deleteToken.bind(this, upgradeToken.id) }>

						<Glyphicon icon="trash" />
					</a>
				);
			}


			if (upgradeToken.user) {
				// B/c of redux flattening, ".user" is actually the user ID
				var userPath = "/users/" + upgradeToken.user + "/details"

				var viewLink = (
					<Link to={ userPath } className="userLink">
						<Glyphicon icon="link" />
					</Link>
				);
			}

			return (
				<tr key={ upgradeToken.id }>
					{this.renderEditableTokenAttributes(upgradeToken, START_DATE, 'date')}
					<td>{ upgradeToken.admin_type }</td>
					{this.renderEditableTokenAttributes(upgradeToken, INVOICE_NUMBER, 'number')}
					{this.renderEditableTokenAttributes(upgradeToken, CONTACT_SCHOOL, 'text')}
					{this.renderEditableTokenAttributes(upgradeToken, CONTACT_NAME, 'text')}
					{this.renderEditableTokenAttributes(upgradeToken, PLAN_TYPE, 'text')}
					{this.renderEditableTokenAttributes(upgradeToken, CODE, 'text')}
					<td>
						{ upgradeIcon }
						{ deleteIcon }
						{ viewLink }
					</td>
				</tr>
			);
		})

		return (
			<table className="table table-bordered tokenTable">
				<tbody>
					<tr>
						<th>Dates</th>
						<th>Admin Type</th>
						<th>Invoice</th>
						<th>School</th>
						<th>Contact/Deal</th>
						<th>Plan</th>
						<th>Code</th>
						<th>Status</th>
					</tr>
					{ tokenRows }
				</tbody>
			</table>
		);
	}

	renderNewTokensForm() {
		if (this.state.showSchoolModal) {
			var schoolModal = (
				<SchoolInfoModal altSubmit={ this.onSelectSchool } allowHide
					onClose={ () => this.setState({ showSchoolModal: false }) } />
			);
		}

		if (this.state.orgData) {
			var schoolText = this.state.orgData.name;
			if (this.state.orgData.canonical_id) {
				schoolText += " (" + this.state.orgData.canonical_id + ")";
			}

			var schoolContent = (
				<div>
					{ schoolText }{" "}
					<button className="btn btn-link schoolButton" onClick={ this.openSchoolModal }>
						Change
					</button>
				</div>
			)
		} else {
			var schoolContent = (
				<button className="btn buttonPrimary schoolButton" onClick={ this.openSchoolModal }>
					Select School
				</button>
			);
		}

		if (this.state.asTrial) {
			var tokenDetailContent = (
				<table className="table table-bordered">
					<tbody>
						<tr>
							<th>Number of tokens</th>
							<th>Trial days</th>
							<th>Label</th>
						</tr>
						<tr>
							<td>
								<input type="number" className="form-control"
									value={ this.state.newTokenCount }
									onChange={ (e) => this.setState({ newTokenCount: e.target.value }) } />
							</td>
							<td>
								<input className="form-control"
									value={ this.state.trialDays }
									onChange={ (e) => this.setState({ trialDays: e.target.value }) } />
							</td>
							<td>
								<input className="form-control" type="email"
									value={ this.state.trialLabel }
									onChange={ (e) => this.setState({ trialLabel: e.target.value }) } />
							</td>
						</tr>
					</tbody>
				</table>
			);


		} else {
			if (this.state.showBulk) {
				var placeholder = "Betty Baker - bbaker@example.k12.ca.org - 2 classes\nCallie Carmel - ccarmel@example.k12.ca.org - 5 classes";
				var bulkTextContent = (
					<div>
						<textarea value={ this.state.bulkText } className="form-control"
							placeholder={ placeholder } rows={ 6 }
							onChange={ (e) => this.setState({ bulkText: e.target.value }) } />

						<button className="btn btn-link" onClick={ this.loadBulkText }>Load</button>
					</div>
				)
			} else {
				var bulkTextContent = (
					<button className="btn btn-link"
						onClick={ (e) => this.setState({ showBulk: true }) }>
						Bulk Enter
					</button>
				)
			}

			var rows = [];

			_.times(this.state.newTokenCount, (index) => {
				var headAdminOption = (
					<option value={ HEAD_ADMIN_TYPE } key={ HEAD_ADMIN_TYPE }>
						Head Admin
					</option>
				)
				var subAdminOption = (
					<option value={ SUB_ADMIN_TYPE } key={ SUB_ADMIN_TYPE }>
						Sub-Admin
					</option>
				)
				var teacherOption = (
					<option value={ TEACHER_TYPE } key={ TEACHER_TYPE }>
						Teacher
					</option>
				)

				if (this.state.districtOrgID) {
					var userType = this.state.tokenUserTypes[index] || HEAD_ADMIN_TYPE;
					var disabledAdminOption = false;
					var adminTypeOptions = [
						headAdminOption,
						subAdminOption
					];

				} else {
					var userType = this.state.tokenUserTypes[index] || TEACHER_TYPE;
					var adminTypeOptions = [
						teacherOption
					];

					if (this.state.schoolOrgID) {
						adminTypeOptions.push(headAdminOption);
						adminTypeOptions.push(subAdminOption);
					}
				}

				rows.push(
					<tr key={ index }>
						<td>
							<select value={ userType }
								className="form-control"
								onChange={ (e) => this.updateTokenField("tokenUserTypes", index, e.target.value) }>

								{ adminTypeOptions }
							</select>
						</td>
						<td>
							<input type="number" className="form-control"
								disabled={ userType !== TEACHER_TYPE }
								value={ this.state.tokenClassCounts[index] || "" }
								onChange={ (e) => this.updateTokenField("tokenClassCounts", index, e.target.value) } />
						</td>
						<td>
							<input className="form-control"
								value={ this.state.tokenNames[index] || "" }
								onChange={ (e) => this.updateTokenField("tokenNames", index, e.target.value) } />
						</td>
						<td>
							<input className="form-control" type="email"
								value={ this.state.tokenEmails[index] || "" }
								onChange={ (e) => this.updateTokenField("tokenEmails", index, e.target.value) } />
						</td>
					</tr>
				);
			});

			var tokenDetailContent = (
				<table className="table table-bordered">
					<tbody>
						<tr>
							<th>User Type</th>
							<th>Class Count</th>
							<th>Name</th>
							<th>Email</th>
						</tr>
						{ rows }
						<tr>
							<td colSpan={ 4 } className="text-center">
								<a href="#" onClick={ this.increaseNewTokenCount }>
									<Glyphicon icon="plus" /> Add Token
								</a>
							</td>
						</tr>
					</tbody>
				</table>
			);
		}

		var selectedPlanOption = this.state.tokenPlanType;
		if (this.state.asTrial) {
			selectedPlanOption += "-trial";
		}

		if (this.isDistrict()) {
			var schoolOptions = this.props.deal.org.child_orgs.filter((x) => {
				return x.custom_fields["School Org ID"];
			}).map((x) => {
				var soID = x.custom_fields["School Org ID"];
				var soIdentifier = OrgTypes.toIdentifier({
					type: OrgTypes.SCHOOL_ORG,
					key: soID
				})
				return (
					<option value={ soIdentifier } key={ soIdentifier }>
						{ x.name }, SchoolOrg ID: { soID }
					</option>
				);
			})

			var dID = this.props.deal.org.custom_fields["District Org ID"];
			if (dID) {
				var doIdentifier = OrgTypes.toIdentifier({
					type: OrgTypes.DISTRICT_ORG,
					key: dID
				})

				var districtOption = (
					<option value={ doIdentifier } key={ doIdentifier }>
						{ this.props.deal.org.name }, DistrictOrg ID: { dID }
					</option>
				)
			}

			if (this.state.schoolOrgID) {
				var currentIdentifier = OrgTypes.toIdentifier({
					type: OrgTypes.SCHOOL_ORG,
					key: this.state.schoolOrgID
				})

			} else if (this.state.districtOrgID) {
				var currentIdentifier = OrgTypes.toIdentifier({
					type: OrgTypes.DISTRICT_ORG,
					key: this.state.districtOrgID
				})

			} else {
				var currentIdentifier = "";
			}

			var onSelectOrgF = (e) => {
				var { type, key } = OrgTypes.fromIdentifier(e.target.value);
				if (type === OrgTypes.DISTRICT_ORG) {
					this.setState({
						districtOrgID: key,
						schoolOrgID: null,
						orgData: {
							name: this.props.deal.org.name
						},
						tokenUserTypes: {}
					})

				} else {
					this.setState({
						districtOrgID: null,
						schoolOrgID: key,
						orgData: this.orgDataForSchoolOrgID(key),
						tokenUserTypes: {}
					})
				}
			}

			var schoolOrgInput = (
				<select className="form-control"
					value={ currentIdentifier }
					onChange={ onSelectOrgF }>
					{ districtOption }
					{ schoolOptions }
				</select>
			);

		} else {
			var schoolOrgInput = (
				<input type="number" className="form-control"
					value={ this.state.schoolOrgID || "" }
					onChange={ (e) => this.setState({ schoolOrgID: e.target.value }) } />
			);
		}

		return (
			<div className="newTokens">
				<p>
					Add new tokens:
				</p>
				<table className="table table-bordered">
					<tbody>
						<tr>
							<th>Plan Type</th>
							<th>Had RLDs</th>
							<th>Start Date</th>
							<th>School/District Org ID</th>
						</tr>
						<tr>
							<td>
								<select value={ selectedPlanOption } className="form-control"
									onChange={ this.onSelectPlanType }>
									{ DropDownOptions.Select.PaidPlanOptions() }
									{ DropDownOptions.Select.PaidPlanTrialOptions() }
								</select>
							</td>
							<td>
								<input type="checkbox" 
									checked={ !!this.state.tokenHasRLD }
									onChange={ (e) => this.setState({ tokenHasRLD: !this.state.tokenHasRLD }) } />
							</td>
							<td>
								<DatePicker className="form-control"
									selected={ moment(this.state.tokenStartDate) }
									onChange={ (date) => this.setState({ tokenStartDate: date.format(DateSpans.FORMAT) }) } />
							</td>
							<td>
								{ schoolOrgInput }
							</td>
						</tr>
						<tr>
							<th>Invoice No.</th>
							<th>ZDS Deal ID</th>
							<th colSpan={ 2 }>School</th>
						</tr>
						<tr>
							<td>
								<input type="number" className="form-control"
									value={ this.state.tokenInvoiceNumber || "" }
									onChange={ (e) => this.setState({ tokenInvoiceNumber: e.target.value }) } />
							</td>
							<td>
								<input type="number" className="form-control"
									value={ this.state.tokenDealID || "" }
									onChange={ (e) => this.setState({ tokenDealID: e.target.value }) } />
							</td>
							<td colSpan={ 2 }>{ schoolContent }</td>
						</tr>
						<tr>
							<th>Sender</th>
							<th colSpan=".5">Max Students</th>
							<th colSpan=".5">Max Student Lists</th>
							<th colSpan="2">Sender Email</th>
						</tr>
						<tr>
							<td>
								<input type="text" className="form-control"
									value={ this.state.senderName || "" }
									onChange={ (e) => this.setState({ senderName: e.target.value }) } />
							</td>
							<td colSpan=".5">
								<input type="number" className="form-control"
									value={this.state.maxStudentOverride || ""}
									onChange={(e) => this.setState({ maxStudentOverride: e.target.value })} />
							</td>
							<td colSpan=".5">
								<input type="number" className="form-control"
									value={this.state.maxStudentListsOverride || ""}
									onChange={(e) => this.setState({ maxStudentListsOverride: e.target.value })} />
							</td>
							<td colSpan="2">
								<input type="text" className="form-control emailPrefix"
									value={ this.state.senderEmailPrefix || "" }
									onChange={ (e) => this.setState({ senderEmailPrefix: e.target.value }) } />{ SENDER_EMAIL_SUFFIX }
							</td>
						</tr>
					</tbody>
				</table>

				{ bulkTextContent }

				{ tokenDetailContent }

				<div className="text-center">
					<button className="btn buttonSuccess" onClick={ this.createTokens }>
						Create Tokens
					</button>
				</div>

				{ schoolModal }
			</div>
		);
	}

	render() {
		if (this.props.loadingUpgradeTokens) {
			var tokenTable = (
				<div>
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			);

		} else {
			if (this.state.copyMode) {
				var innerTokens = this.renderCopyModeTokens();
			} else {
				var innerTokens = this.renderExistingTokensTable();
			}

			var tokenDispaly = (
				<div>
					<p className="text-right smallText">
						<a href="#" onClick={ this.toggleCopyMode }>
							Toggle Copy Mode
						</a> 
					</p>
					{ innerTokens }
					<div className="text-center">
						<button className="btn btn-link" onClick={ this.loadMoreTokens }>
							Load More
						</button>
					</div>
				</div>
			);
		}
		return (
			<div className="upgradeTokenPage container">
				<div className="headerSection">
					<header className="pageHeader">
						<h1>Upgrade Codes</h1>
					</header>

					{ this.renderNewTokensForm() }
					{ this.renderTokenFilter() }
					{ tokenDispaly }
				</div>
			</div>
		);
	}

	componentDidMount() {
		this.props.fetchUpgradeTokens(1, this.getFilterQuery())
	}

};

var SENDER_EMAIL_SUFFIX = "@whooosreading.email";

var TEACHER_TYPE = "teacher";
var HEAD_ADMIN_TYPE = "head-admin";
var SUB_ADMIN_TYPE = "sub-admin";

var START_DATE = 'start_date';
var CREATED_AT = 'created_at';
var INVOICE_NUMBER = 'invoice_number';
var CONTACT_SCHOOL = 'contact_school';
var CONTACT_NAME = 'contact_name';
var CONTACT_EMAIL = 'contact_email';
var STUDENT_LIST_COUNT = 'student_list_count';
var HAS_RLDS = 'has_rlds';
var PLAN_TYPE = 'plan_type';
var CODE = 'code';

var PLAN_OPTIONS = [STUDENT_LIST_COUNT, HAS_RLDS, PLAN_TYPE]

UpgradeTokenPage.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from @connect
	upgradeTokens: PropTypes.array.isRequired,
	deal: PropTypes.object,
	loadingUpgradeTokens: PropTypes.bool,

	// Handlers from @connect
	populateData: PropTypes.func.isRequired,
	createTokens: PropTypes.func.isRequired,
	deleteToken: PropTypes.func.isRequired,
	fetchUpgradeTokens: PropTypes.func.isRequired,
	updateUpgradeTokens: PropTypes.func.isRequired
});

module.exports = UpgradeTokenPage;


// WEBPACK FOOTER //
// ./modules/components/appdev/crm/UpgradeTokenPage.js